// extracted by mini-css-extract-plugin
export var typingIndicator = "_il-0";